import { View, ScrollView, Image, Dimensions } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { Table, Row } from 'react-native-table-component';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = 0;

const Clasification = () => {
  const screenWidth = Dimensions.get('window').width;

  const navigation = useNavigation();
  useLayoutEffect(() => {
    navigation.setOptions({
        headerTitle: transl('League.clasificacionLiga',lang)
    })
  }, []);

  const styles = {
    container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
    header: { height: 50, backgroundColor: '#e6e6e6' },
    text: { textAlign: 'center', fontWeight: 'bold', fontSize:14 },
    row: { height: 40, backgroundColor: '#E7E6E1' }
  };

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
      if(value !== undefined)displayClasi(value)
    })
  }
  readValue()

  lang = dr.idiomas[useSelector((state) => state.language)].value

  let state = { 
    tableHead: ['', transl('League.equipo',lang), transl('League.puntos',lang), transl('League.diferencia',lang), transl('League.tantosFavor',lang), transl('League.tantosContra',lang), transl('League.partidosGanados',lang),transl('League.partidosPerdidos',lang), transl('League.partidosJugados',lang), transl('League.mediaHabilidades',lang)],
    widthArr: [40,120,80,80,80,80,80,80,80,80]
  }

  return (
    <View>
      <ScrollView horizontal={true}>
        <View>
          <Table borderStyle={{borderWidth: 1, borderColor: '#C1C0B9'}}>
              <Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text}/>
          </Table>
          <ScrollView style={styles.dataWrapper}>
            <Table>
              {
                displayClasi(value)
              }
            </Table>
          </ScrollView>
        </View>
      </ScrollView>
    </View>
  )

  function displayClasi(data){
    if(data === undefined || !data) {
      return <Image style={{width:screenWidth,height:screenWidth*0.6}} source={require('./../img/loading.gif')} />
    }
    if(typeof data != "object")data = data != null ? JSON.parse(data) : null
  
    const tableData = [];
    const theTeams = data.teams;
    for (let i = 0; i < theTeams.length; i += 1) {
      const rowData = [];
  
      rowData.push(theTeams[i].name)
      rowData.push(theTeams[i].points)
      rowData.push(theTeams[i].tantosF - theTeams[i].tantosC)
      rowData.push(theTeams[i].tantosF)
      rowData.push(theTeams[i].tantosC)
      rowData.push(theTeams[i].partidosGanados)
      rowData.push(theTeams[i].partidosPerdidos)
      rowData.push(theTeams[i].partidosGanados + theTeams[i].partidosPerdidos)
      
      let totalSkillsSum = 0;
      for (let j = 0; j < 7; j++) {
        let thisPlayerSkills = 0;
        thisPlayerSkills += Number(theTeams[i].players[j].skills.reduce((partialSum, a) => partialSum + a, 0))
        thisPlayerSkills += Number(theTeams[i].players[j].broom.reduce((partialSum, a) => partialSum + a, 0))
        const numberOfAbilities = theTeams[i].players[j].skills.length + theTeams[i].players[j].broom.length
        totalSkillsSum += Number(thisPlayerSkills/numberOfAbilities)
      }
      rowData.push(Number(totalSkillsSum/7).toFixed(2))
      
      tableData.push(rowData);
    }
  
    //trying to sort array
    let sortedTableData = tableData.sort(comparePoints)
  
    let numberMyTeam = 0;
    for(let i = 0; i < sortedTableData.length; i++){
      sortedTableData[i].unshift(i+1)
      if(sortedTableData[i][1] == theTeams[0].name) numberMyTeam = i;
    }
  
    return sortedTableData.map((rowData, index) => (
      <Row
        key={index}
        data={rowData}
        widthArr={state.widthArr}
        textStyle={{textAlign:'center'}}
        style={[
          !(index%2) && {backgroundColor: '#ffffff'},
          {paddingVertical:6},
          index==numberMyTeam && {backgroundColor: '#bfbfbf',borderColor:'#000',borderWidth:1}
        ]}
      />
    ))
  }
}

function comparePoints(a,b){
  if(a[1] > b[1]) return -1
  if(a[1] < b[1]) return 1
  if(a[1] == b[1]) {
    if(a[2] > b[2]) return -1
    if(a[2] < b[2]) return 1
    if(a[2] == b[2]) {
      if(a[5] > b[5]) return -1
      if(a[5] < b[5]) return 1
      if(a[5] == b[5]) {
        if(a[3] > b[3]) return -1
        if(a[3] < b[3]) return 1
        return 0
      }
      return 0
    }
    return 0
  }
  return 0
}




export default Clasification